export interface StatusChipConfig {
  backgroundColor: string;
  color: string;
}

export interface StatusChipProps {
  style: StatusChipConfig;
}

export const STATUS_COLORS = {
  draft: {
    backgroundColor: '#fff3e0',
    color: '#f57c00',
  },
  published: {
    backgroundColor: '#e8f5e8',
    color: '#4caf50',
  },
  default: {
    backgroundColor: '#f5f5f5',
    color: '#000000',
  },
};

export const getStatusChipProps = (status?: string): StatusChipProps => {
  if (!status) {
    return { style: STATUS_COLORS.default };
  }

  const normalizedStatus = status.toLowerCase() as keyof typeof STATUS_COLORS;

  return {
    style: STATUS_COLORS[normalizedStatus] || STATUS_COLORS.default,
  };
};
